import { Table } from "antd";
import React from "react";

function buildDataSource(jobParameters) {
  if (!jobParameters) return [];

  let dataSource = [];
  let keyCounter = 1;

  Object.entries(jobParameters).forEach(([section, params]) => {
    // Add section header
    dataSource.push({
      key: `header-${keyCounter++}`,
      parameter: section,
      value: "",
      isHeader: true,
    });

    params.forEach((paramObj) => {
      const paramName = Object.keys(paramObj)[0];
      const paramValue = paramObj[paramName];

      // Handle value with unit (array: [{Unit: "X"}, "value"])
      if (
        Array.isArray(paramValue) &&
        paramValue.length === 2 &&
        typeof paramValue[0] === "object"
      ) {
        const unit = Object.values(paramValue[0])[0];
        dataSource.push({
          key: keyCounter++,
          parameter: paramName + (unit ? ` (${unit})` : ""),
          value: paramValue[1],
        });
      } else {
        // Simple value
        dataSource.push({
          key: keyCounter++,
          parameter: paramName,
          value: paramValue,
        });
      }
    });
  });

  return dataSource;
}

const JobParameters = ({ jobParameters }) => {
  const dataSource = buildDataSource(jobParameters);

  const columns = [
    {
      title: "",
      dataIndex: "parameter",
      key: "parameter",
      render: (text, record) => {
        if (record.isHeader) {
          return <span style={{ color: "#e03540" }}>{text}</span>;
        }
        return text;
      },
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 2 };
        }
        return {};
      },
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
  ];

  const calcHeight = -150;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;
  return (
    <div
      className="job-parameters-table"
      style={{
        height: tableHeight,
        position: "relative",
      }}
    >
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered={false}
        className="welding-parameters-table"
        showHeader={false}
        scroll={{ y: tableHeight }}
      />
    </div>
  );
};

export default JobParameters;
